module.exports = __webpack_public_path__ + "static/media/horizontal_bar_chart.0295e6ea.svg";